import type { FuelSavingFormValues, TradeSectionData } from '../types';
import { initialState } from '../types';

/**
 * Default form values derived from the Redux initial state.
 * Used as the fallback when a trade has no stored values yet.
 */
export const DEFAULT_TRADE_FORM_VALUES: FuelSavingFormValues = initialState.formValues;

/**
 * Fields that apply to all trades within the same vehicle tab.
 * The new vehicle being purchased is the same for every trade-in comparison,
 * so these values should stay consistent across all trade sections.
 * Driving habits (milesDriven / milesPer) are also universal across all trades and tabs.
 */
export const CROSS_TRADE_FIELDS = new Set<keyof FuelSavingFormValues>([
    'newVehicleMpg',
    'newVehiclePricePerGallon',
    'milesDriven',
    'milesPer'
]);

/**
 * Fields that belong to the trade-in vehicle and should remain consistent
 * across all vehicle tabs for the same trade (the trade-in car doesn't change
 * based on which new vehicle you are comparing it against).
 * Driving habits (milesDriven / milesPer) are universal and therefore also cross-tab.
 */
export const CROSS_TAB_FIELDS = new Set<keyof FuelSavingFormValues>([
    'tradeInMpg',
    'tradePricePerGallon',
    'milesDriven',
    'milesPer'
]);

/**
 * Build the initial expanded/collapsed state for trade sections.
 * Only the first trade is expanded by default.
 */
export const buildExpandedTrades = (trades: TradeSectionData[]): Record<string, boolean> => {
    const expandedMap: Record<string, boolean> = {};

    trades.forEach((trade, index) => {
        expandedMap[trade.id] = index === 0;
    });

    return expandedMap;
};
